import { render, staticRenderFns } from "./claimManagement.vue?vue&type=template&id=190f13a2"
import script from "./claimManagement.vue?vue&type=script&lang=js"
export * from "./claimManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports